import React from "react";
import ProfileChangePasswordComponent from "./ProfileChangePassword";

const ProfileChangePassword = () => {
    return <ProfileChangePasswordComponent />;
};

export default ProfileChangePassword;
